import Vue from 'vue';
import Router from 'vue-router';

// Services
import Brand from '@/services/Brand';

Vue.use(Router);

// Routes
import UmiaRoutes from '@/routing/routes/Umia';
import InsureCareTeamsRoutes from '@/routing/routes/InsureCareTeams';
import MmicRoutes from '@/routing/routes/Mmic';
import AmicRoutes from '@/routing/routes/Amic';
import RrgRoutes from '@/routing/routes/Rrg';

let Routes: any;

switch (Brand.getBrand()) {
	case 'umia':
		Routes = UmiaRoutes;
		break;

	case 'insurecareteams':
		Routes = InsureCareTeamsRoutes;
		break;

	case 'mmic':
		Routes = MmicRoutes;
		break;
	case 'amic':
		Routes = AmicRoutes;
		break;
	
	case 'rrg':
		Routes = RrgRoutes;
		break;

	default:
		Routes = [];
		break;
}

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: Routes,
});

export default router;
